import { html } from "lit-html"

const NoResults = ({ message, onClear }) => html`
  <div
    class="no-results flex flex-col items-center justify-center min-h-144 h-full"
  >
    <p class="mb-6">${message || "No results."}</p>
    <button
      class="button grow-0 bg-transparent text-blue hover:text-red focus:text-red active:text-red"
      data-action="clear"
      type="button"
      @click=${onClear}
    >
      Clear all filters
    </button>
  </div>
`

export default NoResults
